import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface EPPState {
  loading: boolean;
  eppDetails: any | null;
  error: string | null;
}

const initialState: EPPState = {
  loading: false,
  eppDetails: null,
  error: null,
};

const eppSlice = createSlice({
  name: 'epp',
  initialState,
  reducers: {
    eppRequest(
      state,
      action: PayloadAction<{ accountId: string; customerId: string }>
    ) {
      state.loading = true;
      state.error = null;
    },
    eppFetched(state, action: PayloadAction<any>) {
      state.loading = false;
      state.eppDetails = action.payload;
      state.error = null;
    },
    eppFetchFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetEppSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const { eppRequest, eppFetched, eppFetchFailed, resetEppSlice } =
  eppSlice.actions;
export default eppSlice.reducer;
